import moment from "moment";

export const blueCardMethods = {
  calculateOOUDays: (start, end) => {
    return moment(end).startOf("day").diff(moment(start).startOf("day"), "days") + 1;
  },
  groupPeriodsByDateAndEmail: (data) => {
    var periods = [];
    var i = 1;

    // Extract all period data dynamically
    while (data["period" + i + "Date"]) {
      var base = "period" + i;
      var periodObj = { period: base };

      for (var key in data) {
        if (key.indexOf(base) === 0) {
          var shortKey = key.replace(base, "");
          if (shortKey.charAt(0) === shortKey.charAt(0).toUpperCase()) {
            shortKey = shortKey.charAt(0).toUpperCase() + shortKey.slice(1);
          } else {
            shortKey = shortKey.charAt(0).toUpperCase() + shortKey.slice(1);
          }
          periodObj[shortKey] = data[key];
        }
      }

      var date = data[base + "Date"];
      var cert = data[base + "Cert"];
      var email = cert && cert.email ? cert.email : null;

      periodObj._meta = { date: date, email: email };
      periods.push(periodObj);
      i++;
    }

    var groups = [];
    var j = 0;

    while (j < periods.length) {
      var current = periods[j];
      var next = periods[j + 1];

      // if next exists and matches current by date/email → group them (max 2)
      if (next && current._meta.date === next._meta.date && current._meta.email === next._meta.email) {
        groups.push([current, next]);
        j += 2; // skip both (max 2 in a group)
      } else {
        groups.push([current]);
        j += 1;
      }
    }

    // remove helper _meta
    for (var g = 0; g < groups.length; g++) {
      for (var h = 0; h < groups[g].length; h++) {
        delete groups[g][h]._meta;
      }
    }

    return groups;
  },
  processSummaryForPeriodic: (summary) => {
    let days92 = (summary || {}).periodic92Days;
    let days184 = (summary || {}).periodic184Days;
    let grouped92 = blueCardMethods.groupPeriodsByDateAndEmail(days92 || {});
    let grouped184 = blueCardMethods.groupPeriodsByDateAndEmail(days184 || {});
    return { ...summary, periodic92Days: { ...days92, grouped: grouped92 }, periodic184Days: { ...days184, grouped: grouped184 } };
  },
};



// WEBPACK FOOTER //
// ./src/components/BlueCardReport/BlueCardReportView/HelperMethods.js